/**
 * @implements {AbstractView}
 * @constructor
 */
function SettingsListView() {
    var $listview = $('<ul data-role="listview" data-theme="f" data-inset="false">');
    var $content = $('<div id="settingsList">').append($listview);

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "SettingsList";
    };

    /**
     * @override
     * @inheritDoc
     */
    this.show = function() {
        $content.show();
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        return {
            title : $.t("common::settings.title"),
            i18n : "common::settings.title"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    this.resize = function(width, height) {
        $content.height(height);
        $content.width(width);
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getDisplayMode = function() {
        return "menu";
    };

    this.addEntry = function(title, clickFn) {
        var $li = $("<li>").append($("<a>", {text : title}));
        $li.on("click", clickFn);
        $listview.append($li);

        return $li;
    };

    /**
     * @override
     * @inheritDoc
     */
    this.requiresAuthentication = function() {
        return false;
    };
}

SettingsListView.prototype = require("../common/AbstractView");

module.exports = SettingsListView;